import type { StructuredKind } from '@/types/topic';

// Maps a topic type_id to its structured kind. 'select' means the editor lets
// the user pick (Mix). Types absent here default to 'none'.
export const KIND_BY_TYPE_ID: Record<number, StructuredKind | 'select'> = {
  1: 'message', // Message
  2: 'schedule', // Meeting
  3: 'mortgage', // Program
  4: 'select', // Mix
  5: 'none', // Question
  6: 'none', // Support
  7: 'none', // Information
};

export const KIND_LABELS: Record<StructuredKind, string> = {
  mortgage: 'Mortgage program',
  schedule: 'Schedule',
  message: 'Message',
  none: 'None',
};

/** The active structured kind for a topic: fixed by type, or (Mix) the blob's kind. */
export function resolveKind(typeId: number, blobKind: StructuredKind): StructuredKind {
  const reg = KIND_BY_TYPE_ID[typeId];
  if (reg === 'select') return blobKind;
  return reg ?? 'none';
}

/**
 * Whether to render the Structured tab. Mix always shows (it holds the selector).
 * `_blobKind` is accepted for call-site symmetry with resolveKind but unused.
 */
export function showStructuredTab(typeId: number, _blobKind: StructuredKind): boolean {
  const reg = KIND_BY_TYPE_ID[typeId];
  if (reg === 'select') return true;
  return (reg ?? 'none') !== 'none';
}
